export enum PerformanceClass {
  AVERAGE = 'AVERAGE',
  HIGH = 'HIGH',
  LOW = 'LOW',
}

interface DeviceInfo {
  appVersion: string;
  manufacturer: string;
  model: string;
  androidVersion: string;
  sdkVersion: number;
  performanceClass: PerformanceClass;
  majorAndroidVersion: number | undefined;
}

export const getAndroidInfo = (): DeviceInfo | null => {
  const regex =
    /Telegram-Android\/([\d.]+) \(([^;]+) ([^;]+); Android ([^;]+); SDK (\d+); ([^)]+)\)/;
  const match = navigator.userAgent.match(regex);

  // Return null if the User-Agent string doesn't match the expected pattern
  if (!match) return null;

  const [
    ,
    appVersion,
    manufacturer,
    model,
    androidVersion,
    sdkVersion,
    performanceClass,
  ] = match;

  const versionParts = androidVersion?.split('.').map(Number);
  const majorAndroidVersion = versionParts[0] || undefined;

  return {
    appVersion,
    manufacturer,
    model,
    androidVersion,
    majorAndroidVersion,
    sdkVersion: parseInt(sdkVersion, 10),
    performanceClass: performanceClass as PerformanceClass,
  };
};
